<!--
 * @Author: zn
 * @Date: 2022-09-14 16:30:35
 * @LastEditors: zn
 * @LastEditTime: 2022-10-12 10:46:46
 * @FilePath: \huangshi_door\src\views\center\declarePage.vue
-->
<template>
  <div class="declare_page">
<!--    <h3 class="title">我的项目</h3>-->
     <el-tabs class="applyTab" v-model="activeName" @tab-click="handleClick">
       <el-tab-pane class="tabTitle" label="申报项目" name="first">
         <declare-all></declare-all>
       </el-tab-pane>
      <el-tab-pane class="tabTitle" label="我的项目" name="second">
        <apply-all></apply-all>
      </el-tab-pane>

      <!--<el-tab-pane class="tabTitle" label="待审核" name="third">
        <apply-pass></apply-pass>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="待分配" name="fourth">
        <apply-reject></apply-reject>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="待公示" name="fifth">
        <upload-data></upload-data>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="待拨付" name="sixth">
        <to-cash></to-cash>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="已兑现" name="seventh">
        <give-up></give-up>
      </el-tab-pane>-->
    </el-tabs>
  </div>
  <!-- <div
    style="display: flex; flex-direction: column; justify-content: center; align-items: center;margin-top: 100px;"
  >
    <img src="../../assets/images/center/recom.png" alt="" />
    <p style="font-size: 30px; color:#999">敬请期待！</p>
  </div> -->
</template>

<script>
import ApplyAll from "./declareComponent/ApplyAll.vue";
import DeclareAll from "./declareComponent/DeclareAll.vue";
import ApplyIng from "./declareComponent/ApplyIng.vue";
import ApplyPass from "./declareComponent/ApplyPass.vue";
import ApplyReject from "./declareComponent/ApplyReject.vue";
import UploadData from "./declareComponent/UploadData.vue";
import ToCash from "./declareComponent/ToCash.vue";
import GiveUp from "./declareComponent/GiveUp.vue";
export default {
  name: "declarePage",
  components: {
    ApplyAll,
    DeclareAll,
    ApplyIng,
    ApplyPass,
    ApplyReject,
    UploadData,
    ToCash,
    GiveUp,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss">
.declare_page {
  .title {
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
    color: rgba(56, 56, 56, 1);
    margin: 0 0 15px 0;
  }
  .applyTab {
    /deep/ .el-tabs__header{
      .el-tabs__nav-wrap{
        .el-tabs__nav-scroll{
          .el-tabs__nav{
            .el-tabs__active-bar{
              transform: none !important;
            }
          }
        }
      }
    }
  }
    .applyTab {
    /deep/.el-tabs__item {
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: rgba(56, 56, 56, 1);
    }
    /deep/.selectForm {
      .el-form-item {
        margin-right: 5%;
      }
      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }
  }
}
</style>
